module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/5_83ad23a3b91a99f902501a7b1323e11d.png";